

const metertext = {
    key: "Clé/code",
    name: "Nom",
    meternumber: "Numéro de compteur",
    serialnumber: "Matricule",
    energy: "Energie",
    divisionunit: "Clé de répartition - Unité",
    divisionvalue: "Clé de répartition - Valeur",
    uuid: "Clé unique",
    group: "Groupe",
    idgroup: "Identifiant du groupe",
    account: "Compte",
    accountid: "Identifiant du compte",
    group: "Groupe",
    address: "Adresse du compteur",
    totaldistributionpercent: "Distribution totale (%)",
    totaldistributionsqmtr: "Distribution totale (m²)",
    distributionsitecount: "Nombre de distribution",
    distribution: "Distribution",
    comments: "Commentaires",
    description: "Description",
    segment: "Segment",
    cja: "CJA",
    diameter: "Diamètre",
    status: "Statut",
    sitestatus: "Statut de l'entité",
    loadcurvestatus: "Etat courbe de charge",
    monthlydatastatus: "Etat de la relève",
    monthlydatadate: "Date de la dernière relève",
    authorizationstatus : "Autorisation distributeur",
    dailydatastatus: "Etat données journalières",
    dailydatadate: "Date dernière donnée journalière",
    monthlydatafrequency: "Fréquence de relève",
    historicalrequeststatus: "Requête d'historique",
    meters: "compteur(s)",

}

const meterspagetext = {
    energychoice: "Energie",
    yearchoice: "Année",
    typechoice: "Type de données",
    shownodata: "Afficher les compteurs sans valeurs"
}

const metersdatapagetext = {
    site : "Entité",
    type : "Valeurs à afficher",
    method : "Agrégation",
    display : "Affichage",
    date : "Date",
    value : "Valeur",
    nodata : "Aucune valeur à afficher",
    daterange : "Voir la donnée sur",
    datebegin : "Date de début",
    dateend : "Date de fin",
}
const metershistoricalpagetext = {
    type : "Valeurs à récupérer",
    datebegin : "Date de début",
    dateend : "Date de fin",
    wrongrangedateend : "La date de fin ne peut pas être postérieure à la date actuelle",
    wrongrangedateenddatebegin : "La date de début ne peut pas être postérieure à la date de fin",
    wrongrangetoobig : "La demande d'historique ne peut pas faire plus de 1 an",
    nodata : "Aucun historique demandé",
}
const metersadminpagetext = {
    type : "Valeurs à envoyer",
    datebegin : "Date de début",
    dateend : "Date de fin",
    wrongrangedateend : "La date de fin ne peut pas être postérieure à la date actuelle",
    wrongrangedateenddatebegin : "La date de début ne peut pas être postérieure à la date de fin",
    wrongrangetoobig : "La demande d'historique ne peut pas faire plus de 1 an",
    nodata : "Aucun historique demandé",
    format: "Format",
    warningbillrecreate: "Attention, les anciennes répartition de relèves visible dans le module compteur seront supprimées",
    sendzero: "Envoyer des zeros au moteur de calcul"
}

export {metertext, meterspagetext, metersdatapagetext, metershistoricalpagetext, metersadminpagetext};
